import React, { useState } from "react";
import {
  Button,
  Dropdown,
  Modal,
  ModalHeader,
  ModalContent,
  ModalActions,
  Form,
  Input,
  Checkbox
} from "semantic-ui-react";
import { statusColorMap } from "../commitmentInstructions/helpers/statusColorMap";

export default function NewOmitOptionModal({
  setOpen,
  statusTypes,
  addOmitOptionToExistingOmitOptions,
  optionAttemptedToAdd
}) {
  const [text, setText] = useState(optionAttemptedToAdd);
  const [status, setStatus] = useState(null);
  const [isDefault, setIsDefault] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const save = async () => {
    const omitToAdd = {
      text,
      statusApplicableTo: status.id,
      newTaskDefinitions: [],
      isDefault,
      statusApplicableToDescription: status.description
    };
    addOmitOptionToExistingOmitOptions(omitToAdd);
    setOpen(false);
  };

  const preventPropagation = event => {
    event.stopPropagation();
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={true}
      trigger={<Button>Show Modal</Button>}
      onClick={preventPropagation}
    >
      <ModalHeader>New Omit Option</ModalHeader>
      <ModalContent
        style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}
        onClick={preventPropagation}
      >
        <Input
          size="large"
          placeholder="Omit Option Text"
          style={{ width: "65%" }}
          value={text}
          onChange={(e, { value }) => setText(value)}
        />

        <Dropdown
          style={{ width: "65%", fontSize: "16px" }}
          selection
          placeholder="Select a status option"
          clearable
          size="large"
          value={status}
          onChange={(e, { value }) => setStatus(value)}
          options={statusTypes.map(option => ({
            ...option,
            text: option.description,
            value: option,
            content: (
              <div>
                <span style={{ color: statusColorMap[option.id], fontWeight: "bold" }}>{option.description}</span>
              </div>
            )
          }))}
          text={
            status && (
              <div>
                <span
                  style={{
                    color: statusColorMap[status.id],
                    fontWeight: "bold"
                  }}
                >
                  {status.description}
                </span>
              </div>
            )
          }
        />
        <Checkbox
          label="Is a default option"
          checked={isDefault}
          size="large"
          onClick={(e, { checked }) => setIsDefault(checked)}
          style={{ width: "65%" }}
        />
      </ModalContent>
      <ModalActions>
        <Button color="black" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button onClick={save} positive disabled={submitting || !status || !text}>
          {submitting ? "Saving..." : "Save"}
        </Button>
      </ModalActions>
    </Modal>
  );
}
